// src/components/CustomModal/CustomModal.js
import React from "react";
import "./CustomModal.css"; // Asegúrate de tener este archivo de estilos

const CustomModal = ({ isOpen, title, message, type, onClose, onConfirm }) => {
  // Si el modal no está abierto, no renderiza nada
  if (!isOpen) {
    return null;
  }

  // Clases CSS dinámicas para el color del título según el tipo
  let headerColorClass = "";
  let iconComponent = null;

  switch (type) {
    case "success":
      iconComponent = (
        <i className="bi bi-check-circle-fill fs-3 text-success me-2"></i>
      );
      break;
    case "info":
      headerColorClass = "text-info";
      iconComponent = (
        <i className="bi bi-info-circle-fill fs-3 text-info me-2"></i>
      );
      break;
    case "error":
      headerColorClass = "text-danger";
      iconComponent = (
        <i className="bi bi-exclamation-triangle-fill fs-3 text-danger me-2"></i>
      );
      break;
    case "confirm":
      headerColorClass = "text-primary";
      iconComponent = (
        <i className="bi bi-question-circle-fill fs-3 text-primary me-2"></i>
      );
      break;
    default:
      headerColorClass = "";
  }

  return (
    <div className="custom-modal-backdrop">
      <div className="custom-modal">
        <div className="modal-header d-flex align-items-center">
          {iconComponent}
          <h5 className={`modal-title mb-0 ${headerColorClass}`}>{title}</h5>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer d-flex justify-content-end">
          {/* Renderiza los botones condicionalmente según el tipo de modal */}
          {type === "confirm" ? (
            <>
              {/* Botón "Cancelar" para el modal de confirmación */}
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Cancelar
              </button>
              {/* Botón "Aceptar" para el modal de confirmación */}
              <button
                type="button"
                className="btn btn-danger"
                onClick={onConfirm}
              >
                Aceptar
              </button>
            </>
          ) : (
            // Botón único para otros tipos de modales (info, error)
            <button type="button" className="btn btn-primary" onClick={onClose}>
              Aceptar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
